'use strict';
window.jQuery = window.$ = require("jquery");
require('object.assign').shim();
require('ngFileUploadShim'); // Needs to be loaded before angular
require('flatpickr');
require('angular');
require('angular-resource');
require('angular-animate');
require('angular-sanitize');
require('angular-ui-router');
require('angular-translate');
require('ng-file-upload');
require('angular-xeditable');
require('ng-tags-input');
require('angular-bootstrap-colorpicker');
require('angular-growl-v2');
require('angular-strap');
require('angular-timer');
require('angular-elastic');
require('angular-mw-typeahead');
require('./app/angular-chart.js');
require('angular-google-places-autocomplete');
require('es6-shim');
require('./app/widgets/sortable.js');
require('./app/jquery.ui.touch-punch.js');
require('angular-ui-sortable');
require('angular-ui-sortable-multiselection');

require('angular-ui-tinymce');
require('tinymce');
require('tinymce/themes/modern/theme');
require('tinymce/plugins/paste');
require('tinymce/plugins/autolink');
require('tinymce/plugins/link');
require('tinymce/plugins/media');
require('tinymce/plugins/hr');
require('tinymce/plugins/lists');
require('tinymce/plugins/textcolor');
require('tinymce/plugins/colorpicker');
require('tinymce/plugins/table');
require('tinymce/plugins/image');
require('gridstack/dist/gridstack');
require('./app/gridstack.jQueryUI');


require('angular-clipboard');

require("moment").locale("sv-se");

// Declare app level module which depends on filters, and services
angular.module('dokiv', [
  'ngResource',
  'ngAnimate',
  'ngSanitize',
  'ui.router',
  'pascalprecht.translate',
  'ngFileUpload',
  'xeditable',
  'ngTagsInput',
  'colorpicker.module',
  'ngPasswordGenerator',
  'angular-growl',
  'mgcrea.ngStrap',
  'timer',
  'mw-typeahead',
  'monospaced.elastic',
  'angular-clipboard',
  'chart.js',
  'google.places',
  'ui.sortable',
  'ui.sortable.multiselection', 
  'ui.tinymce'
])
  .factory("dokivTranslateLocalStorage", function() {
    return {
      set: function(key, value) {
        if(window.localStorage) {
          window.localStorage.setItem(key, value);
        }
      },
      get: function(key) {
        if(window.localStorage) {
          return window.localStorage.getItem(key);
        }
      }
    };
  })
  .config(['$translateProvider', function($translateProvider) {
    $translateProvider.useLoader('TranslateCustomLoader', {});
    //$translateProvider.use('en_US');
    // Tell the module what language to use by default
    $translateProvider.preferredLanguage('en');
  }])
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.defaults.timeout = 30000;
  }])
  .factory('TranslateCustomLoader', ['$http', '$q', function($http, $q) {
    return function (options) {
      var deferred = $q.defer();
      $http({
        method:'GET',
        url:'locale/locale-' + options.key + '.json?appHash=' + APP_HASH
      }).success(function (data) {
        deferred.resolve(data);
      }).error(function () {
        deferred.reject(options.key);
      });
      return deferred.promise;
    };
  }])
  .config(['growlProvider', function(growlProvider) {
    growlProvider.globalTimeToLive(4000);
  }])
  .config(['mwTypeaheadConfigProvider', function(mwTypeaheadConfigProvider) {
    mwTypeaheadConfigProvider.setActiveClass('active');
  }])
  .filter('bytes', function() {
    return function(bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
        return '-';
      }
      if (typeof precision === 'undefined') {
        precision = 1;
      }
      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
        number = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
    };
  });


angular.module('dokiv')

  .config(['$datepickerProvider', function($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
      startWeek: 1
    });
  }])

  .constant('publicationTypes', [
    'ORDER',
    'DEFAULT',
    'ALBUM',
    'FOLDER',
    'NOTE',
    'FORM',
    'KEYPASS',
    'WALL',
    'PLANT',
    'COMPANY_ORDER',
    'ORDER_SUBCRIPTION',
    'BLOG',
    'INVESTIGATION',
    'SK3_FOLDER']
  )

  .run(['$rootScope', '$sce', '$state', '$translate', '$location', 'growl', 'config', '$compile', 'CurrentUserService', function($rootScope, $sce, $state, $translate, $location, growl, config, $compile, currentUserService) {

    $rootScope.$on('$stateChangeStart', function() {
      $rootScope.loading = true;
    });

    var emojiList = ['😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓', '😛', '😜', '😠', '😇', '😷', '😈', '👻', 
                '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈', '🙉', '🙊', '👼', '👮', '🕵️', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃', 
                '⛷', '🏂', '🏌️', '🏄', '🚣', '🏊', '⛹️', '🏋️', '🚴', '👫', '💪', '👈', '👉', '👆', '🖕', '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', 
                '🙌', '🙏', '🐵', '🐶', '🐇', '🐥', '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸', '🍺', '🌍', 
                '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌧', '🌩', '⛄', '🔥', '🎄', '🎈', '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', 
                '🎵', '🎷', '💰', '🖊', '📅', '✅', '❎', '💯'];

    $rootScope.tinymceOptions = {
      format: "raw",
      setup: function(editor) {
        editor.on('NodeChange', function (e) {
          if(e.element.tagName === "IMG"){          
            e.element.setAttribute("class", "image-editor");
          }
        });
        editor.editorManager.AddOnManager.PluginManager.add("emojis", function(
          editor
        ) {
          var html = "<div>";
          emojiList.forEach(function(emoji){
            html +=
              '<span style="float:left; padding: 4px; font-size: 1.5em; cursor: pointer;" data-chr="' +
              emoji +
              '">' +
              emoji +
              "</span>";
          });

          html += "</div>";

          var body = [
            {
              type: "container",
              title: "emojis",
              html: html,
              onClick: function(e) {
                var target = e.target;
                if (/^(SPAN)$/.test(target.nodeName)) {
                  if (target.hasAttribute("data-chr")) {
                    var char = target.getAttribute("data-chr");
                    editor.execCommand(
                      "mceInsertContent",
                      false,
                      char
                    );
                  }
                }
              }
            }
          ];

          function showDialog() {
            var win = editor.windowManager.open({
              autoScroll: true,
              width: 300,
              height: 250,
              title: "Insert Emoji",
              bodyType: "container",
              layout: "fit",
              body: body,
              buttons: [
                {
                  text: "Close",
                  onclick: function(){
                    win.close();
                  }
                }
              ]
            });
          }

          editor.addCommand("emojiShowDialog", showDialog);
          editor.addButton("tinymceEmoji", {
            text: "😀",
            icon: false,
            cmd: "emojiShowDialog"
          });
        });
      },
      content_css : "../../../styles/components/tinymce.css",
      height: '500',
      plugins:
        'emojis image autolink link paste media hr lists textcolor colorpicker table',
      toolbar:
        'formatselect | bold italic underline strikethrough | subscript superscript hr | forecolor backcolor tinymceEmoji link image media | alignleft aligncenter alignright alignjustify | fontsizeselect | fontselect | undo redo | numlist bullist outdent indent table  | removeformat',
      branding: false,
      menubar: false
    };

    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      $rootScope.loading      = false;
      $rootScope.currentState = toState;
    });

    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
      $rootScope.loading = false;

      switch(error.status) {
        case 401:
          window.location.href = '/login?redirect='+$location.url();
          break;
        case 403:
          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
            $state.get('root.company.403').error = error;
            $state.go('root.company.403', {}, { location: false });
          } else {
            $state.get('403').error = error;
            $state.go('403', {}, { location: false });
          }
          break;
        case 404:
          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
            $state.get('root.company.404').error = error;
            $state.go('root.company.404', {}, { location: false });
          } else {
            $state.get('404').error = error;
            $state.go('404', {}, { location: false });
          }
          break;
        case 0:
          growl.addErrorMessage(
            $translate.instant('error.network-connectivity-issues') + '. <a href="#" onclick="window.location.reload()"><i class="fa fa-refresh"></i> ' + $translate.instant('click-to-reload-page') + '</a>',
            {
              ttl: -1,
              enableHtml: true
            }
          );
          break;
        default:
          if (error && error.config && error.config.url === config.apiBase + "/files/startpage_300") {
            break;
          }
          
          if(toState.name.indexOf('root.company.') !== -1 && fromParams.companyId) {
            $state.get('root.company.error').error = error;
            $state.go('root.company.error', {}, { location: false });
          } else {
            $state.get('error').error = error;
            $state.go('error', {}, { location: false });
          }
      }
      throw error;
    });

    var keyMap = 'https://maps.googleapis.com/maps/api/js?libraries=places&key='+config.keyMap;
    var domElem = '<script src="'+keyMap+'"></script>';
    angular.element('html head').append(domElem);
    
    var clientId = 'https://apis.google.com/js/client:platform.js?onload=start';
    var domElem2 = '<script src="'+clientId+'"></script><script>function start() {gapi.load("auth2", function() {auth2 = gapi.auth2.init({client_id: "'+config.clienID+'", fetch_basic_profile: true, scope: "profile"});});}</script>';
    angular.element('html head').append(domElem2);

    if(window["WebSocket"]) {
      var updateSocket = null;
      var reconnecting = null;

      var createWebsocket = function(userId) {
        if(updateSocket) {
          updateSocket.close();
        }

        updateSocket = new WebSocket(config.apiBase.replace("http://", "ws://").replace("https://", "wss://") + "/webapp-updates?userId="+userId);

        updateSocket.onerror = function() {
          if(window.console) {
            window.console.log('Websocket error:', arguments);
          }
        };

        updateSocket.onclose = function() {
          if(!reconnecting) {
            reconnecting = setTimeout(function() {
              reconnecting = null;
              createWebsocket(userId);
            }, 5000);
          }
        };
        updateSocket.onmessage = function(data) {
          var message = angular.fromJson(data.data);
          if (message) {
            if(message.notification) {
              $rootScope.$broadcast('notification', message.notification);
            }
            if(message.event && (message.event.name === 'EDITTING' || message.event.name === 'END_EDIT')) {
              $rootScope.$broadcast('edittingObject', message.event);
            }
            if(message.event === 'RELOAD_DASHBOARD') {
              $rootScope.$broadcast('eventReloadDashboard', message.event);
            } if(message.event === 'SERVICE_TIMESTAMP') {
              $rootScope.$broadcast('eventServiceTimestamp', message);
            }

            if (message.event === 'SEND_ACL') {
              $rootScope.$broadcast('eventModifyPermissions', message.acls);
            }
            if (message.event === 'SEND_READ_NOTIFICATION') {
              $rootScope.$broadcast('eventReadNotification');
            }
          }
        };
      };

      if(window.localStorage && window.localStorage.userId) {
        currentUserService.get().then(function(user) {
          createWebsocket(user.id);
        });
      }

      $rootScope.$on('auth-login', function(e, args) {
        createWebsocket(args.userId);
      });
      $rootScope.$on('auth-logout', function() {
        if(updateSocket) {
          /* Hack to prevent reconnect */
          reconnecting = true;
          updateSocket.close();
          reconnecting = false;
        }
      });
    }

    $rootScope.sendUpdateEdit = function(isEdit, currentUser, publication){
      if(isEdit){
        updateSocket.send(JSON.stringify(
          { 
            event: "EDITTING",
            user: {
                "id": currentUser.id,
                "email": currentUser.email
            },
            object:{
                "id": publication.id,
                "name": publication.name
            }
          }
        ));
      }else{
        updateSocket.send(JSON.stringify(
          { 
            event: "END_EDIT",
            user: {
                "id": currentUser.id,
                "email": currentUser.email
            },
            object:{
                "id": publication.id,
                "name": publication.name
            }
          }
        ));
      }
    };

    $rootScope.trustAsHtml = function(string) {
      return $sce.trustAsHtml(string);
    };
  }]);

require('./app/stateSnapshot.js');
require('./app/ARGB2HexFilter.js');
require('./app/ARGBTextColorFilter.js');
require('./app/ARGB2HexDirective.js');
require('./app/TooltipDirective.js');
require('./app/ArrowNavDirective.js');
require('./app/UserEnterDirective.js');
require('./app/InfoBoxDirective.js');
require('./app/ExecOnBlurDirective.js');
require('./app/customAutoFocusDirective.js');
require('./app/nl2brFilter.js');
require('./app/MarkdownFilter.js');
require('./user/UserAvatarDirective.js');
require('./user/CurrentUserService.js');
require('./user/PwCheckDirective.js');
require('./app/FormDirtyConfirmDirective.js');
require('./company/publications/CompanyPublicationFilePreviewDirective.js');
require('./company/publications/PublicationStarDirective.js');
require('./company/forms/viewQuestionDetailsDirective.js');
require('./company/CompanyLogoDirective.js');
require('./config.js');
require('./auth/AuthInterceptor.js');
require('./routes.js');
require('./growl-custom.js');
require('./app/BindEarlyAttrDirective.js');
require('./app/FreehandCanvas.js');
require('./app/DokivPrint.js');
require('./app/ReverseFilter.js');
require('./app/TogglePasswordDirective.js');
require('./app/reminderFilterExpired.js');
require('./app/encodeUrl.js');
require('./app/scrollbarOnTopContent.js');
require('./app/DecacheImage.js');
require('./app/AngularFlatpickr.js');
require('./app/selectAllOnFocus.js');
require('./app/angular-footable.js');
require('./app/goBack.js');
require('./app/GroupMembersDirective.js');
require('./app/TextCarouselDirective.js');
require('./app/ReadMoreLessToggle.js');
require('./app/orInfinFilter.js');
require('./app/ng-password-generator.js');
require('./app/CompanyFeedService.js');
require('./app/sglClick.js');


//////////////////
// WEBPACK FOOTER
// ./scripts/app.js
// module id = 0
// module chunks = 0